import { ColoredIcon } from 'component/ColoredIcon'
import styled from 'styled-components'
import themeAsseticonCloseSvg from '@theme/icon/close.svg'

export const PlaceboChooserModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.41026rem;
  align-self: stretch;
  background: #161616;
  border-radius: 0.51282rem 0.51282rem 0 0;
  overflow: hidden;
`

export const PlaceboChooserModalNav = styled.div`
  display: flex;
  padding: 0.41026rem 0.41026rem 0.30769rem 0.41026rem;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  position: relative;
`

export const PlaceboChooserModalTitle = styled.div`
  color: #fff;
  font-size: 0.41026rem;
  font-weight: 500;
  line-height: 0.61538rem; /* 150% */
`

export const PlaceboChooserModalNavCloseButton = styled(ColoredIcon).attrs((props) => ({
  ...props,
  src: themeAsseticonCloseSvg,
  color: '#fff',
}))`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.41026rem;
  width: 0.61538rem;
  height: 0.61538rem;
`

export const PlaceboChooserModalItem = styled.div`
  display: flex;
  width: 8.79487rem;
  padding: 0.41026rem;
  justify-content: space-between;
  align-items: center;

  color: #fff;
  font-size: 0.35897rem;
  line-height: 0.51282rem; /* 142.857% */
`

export const PlaceboChooserModalItemButton = styled.button`
  display: flex;
  height: 0.61538rem;
  min-width: 1.48718rem;
  padding: 0 0.20513rem;
  justify-content: center;
  align-items: center;
  gap: 0.10256rem;

  border-radius: 0.10256rem;
  border: 1px solid #fff;

  color: #fff;
  font-size: 0.30769rem;
  font-weight: 400;
  line-height: 0.35897rem;
`

export const FooterSpacer = styled.div`
  height: env(safe-area-inset-bottom, 0);
`
